export const ACCEPT_FILETYPE = [
  'hwp',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'pdf',
  'jpg',
  'jpeg',
  'png',
  'gif',
  'bmp',
  'tiff',
  'tif',
];

const MEGA_BYTE = 1024 * 1024;
export const MAX_FILE_UPLOAD_MEGA_BYTE = 5;
export const MAX_FILE_UPLOAD_BYTE = MAX_FILE_UPLOAD_MEGA_BYTE * MEGA_BYTE;
export const MAX_FILE_UPLOAD_BYTE_ERROR_MESSAGE = `최대 업로드 가능 용량은 ${MAX_FILE_UPLOAD_MEGA_BYTE}MB입니다.`;

export const GOOGLE_DOCUMENT_MIME_TYPE = 'application/vnd.google-apps.document';
export const GOOGLE_DOCUMENT_MAX_FILE_UPLOAD_MEGA_BYTE = 8;
export const GOOGLE_DOCUMENT_MAX_FILE_UPLOAD_BYTE =
  GOOGLE_DOCUMENT_MAX_FILE_UPLOAD_MEGA_BYTE * MEGA_BYTE;
export const GOOGLE_DOCUMENT_MAX_FILE_UPLOAD_BYTE_ERROR_MESSAGE = `구글문서 최대 업로드 가능 용량은 ${GOOGLE_DOCUMENT_MAX_FILE_UPLOAD_MEGA_BYTE}MB입니다.`;
